import { render, staticRenderFns } from "./MessagePreviewList.vue?vue&type=template&id=05dc1a0d&"
import script from "./MessagePreviewList.vue?vue&type=script&lang=js&"
export * from "./MessagePreviewList.vue?vue&type=script&lang=js&"
import style0 from "./MessagePreviewList.vue?vue&type=style&index=0&id=05dc1a0d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports